import { useEffect } from "react";

export function useEndOfScroll({
  ref,
  callback,
  offset = 100,
  enabled = true,
}: {
  ref?: React.RefObject<HTMLElement> | null;
  callback: () => void;
  offset?: number;
  enabled?: boolean;
}) {
  useEffect(() => {
    if (!enabled) return;

    const target = ref?.current ?? window;

    const handleScroll = () => {
      let scrollTop, scrollHeight, clientHeight;
      if (typeof window === "undefined") return;
      if (ref?.current) {
        const el = ref.current;
        scrollTop = el.scrollTop;
        scrollHeight = el.scrollHeight;
        clientHeight = el.clientHeight;
      } else {
        scrollTop = window.scrollY;
        scrollHeight = document.documentElement.scrollHeight;
        clientHeight = window.innerHeight;
      }

      if (scrollTop + clientHeight >= scrollHeight - offset) {
        callback();
      }
    };

    target.addEventListener("scroll", handleScroll);
    return () => target.removeEventListener("scroll", handleScroll);
  }, [ref, callback, offset, enabled]);
}
